<template>
  <article class="question-card">
    <header><span class="question-number">Soru {{ number }}</span><div class="question-actions">
      <button v-if="content.questionAudioFile" type="button" @click="playing ? pause() : play()"><i :class="playing ? 'bi bi-pause-fill' : 'bi bi-play-fill'" aria-hidden="true"></i> {{ playing ? 'Duraklat' : 'Dinle' }}</button>
    </div></header>
    <p class="question-text" lang="en">{{ content.question }}</p>
    <p v-if="language === 'tr-TR' && translation" class="question-translation" lang="tr">{{ translation }}</p>
    <p v-if="error" role="status" class="question-error">{{ error }}</p>
    <audio ref="audio" :src="audioUrl || undefined" preload="none" @ended="playing = false" @error="audioError"></audio>
  </article>
</template>
<script>
export default {
  name: 'QuestionPracticeCard',
  emits: ['focus'],
  props: {content: {type: Object, required: true}, number: Number, speed: {type: Number, default: 1}, language: {type: String, default: 'en-EN'}},
  data() { return {playing: false, error: '', request: 0}; },
  computed: {
    translation() { return this.content.languages?.find(item => item.languageCode === 'tr-TR')?.question; },
    audioUrl() { return this.content.questionAudioFile ? process.env.VUE_APP_ROOT_API + 'Source/dictionary/bookquestionaudio?fileName=' + encodeURIComponent(this.content.questionAudioFile) : ''; }
  },
  methods: {
    pause() { this.request++; this.$refs.audio?.pause(); this.playing = false; },
    stopAudio() { this.pause(); if (this.$refs.audio) this.$refs.audio.currentTime = 0; },
    async play() {
      if (!this.audioUrl) return;
      this.$emit('focus');
      this.error = ''; const request = ++this.request;
      try {
        this.$refs.audio.playbackRate = this.speed;
        await this.$refs.audio.play();
        if (request === this.request) this.playing = true;
      } catch (error) { if (request === this.request && error?.name !== 'AbortError') this.audioError(); }
    },
    audioError() { if (!this.audioUrl) return; this.pause(); this.error = 'Ses açılamadı. Lütfen yeniden deneyin.'; }
  },
  watch: {
    speed(value) { if (this.$refs.audio) this.$refs.audio.playbackRate = value; },
    language() { this.stopAudio(); },
    content() { this.stopAudio(); this.error = ''; }
  },
  beforeUnmount() { this.stopAudio(); }
};
</script>
<style scoped>
.question-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 20px; }
header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
.question-number { color: var(--brand-primary-hover); background: #ecfdf5; border-radius: 8px; padding: 6px 10px; font-size: 13px; font-weight: 600; }
.question-actions { display: flex; gap: 8px; flex-wrap: wrap; }
button { min-height: 40px; padding: 8px 12px; border: 1px solid #d8e5dd; border-radius: 9px; color: var(--brand-primary-hover); background: white; font-size: 14px; }
button:hover, button[aria-pressed="true"] { background: #ecfdf5; }
button:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 2px; }
.question-text { color: #334155; font-size: 18px; line-height: 1.75; margin: 0; overflow-wrap: anywhere; }
.question-translation { color: #64748b; background: #f8fafc; padding: 12px; border-radius: 8px; margin: 12px 0 0; line-height: 1.7; }
.question-error { color: #b45309; font-size: 14px; }
@media(max-width: 575px) { .question-card { padding: 16px; } .question-text { font-size: 17px; } }
</style>
